import api from "./authService";

// API functions for payments
export const paymentApi = {
  // Create payment intent for a booking (legacy - requires existing booking)
  createPaymentIntent: async (bookingData) => {
    const metadata = bookingData.metadata || {};
    const response = await api.post('/payments/create-intent', {
      booking_id: bookingData.bookingId,
      amount: bookingData.amount,
      currency: bookingData.currency || 'USD',
      payment_type: bookingData.paymentType || 'deposit', // 'deposit' or 'full_payment'
      metadata: {
        ...metadata,
        // Include payment percentage and proportional platform fee if available
        paymentPercentage: metadata.paymentPercentage || null,
        paymentPlatformFee: metadata.paymentPlatformFee || null,
        totalPlatformFee: metadata.totalPlatformFee || null
      }
    });
    return response.data;
  },

  // Create payment intent with booking data (new - creates booking after payment)
  createPaymentIntentWithBooking: async (bookingData) => {
    const response = await api.post('/payments/create-intent-with-booking', {
      ...bookingData,
      amount: bookingData.amount,
      currency: bookingData.currency || 'USD',
      payment_type: bookingData.paymentType || 'deposit',
    });
    return response.data;
  },

  // Confirm payment with payment intent (booking_id is optional now)
  confirmPayment: async (paymentIntentId, bookingId = null) => {
    const response = await api.post('/payments/confirm', {
      payment_intent_id: paymentIntentId,
      booking_id: bookingId
    });
    return response.data;
  },

  // Get payment status
  getPaymentStatus: async (paymentIntentId) => {
    const response = await api.get(`/payments/status/${paymentIntentId}`);
    return response.data;
  },

  // Get payment by booking ID
  getPaymentByBooking: async (bookingId) => {
    const response = await api.get(`/payments/booking/${bookingId}`);
    return response.data;
  }
};

export default paymentApi;

